import { useAppShellLayout } from '@/components/AppShell/useAppShellLayout'
import { IntegrationsModalProvider } from '@/components/IntegrationsModal/IntegrationsModalContext'
import { SettingsModalProvider } from '@/components/Settings/SettingsModal/SettingsModalContext'
import AppShellLayoutView from './AppShellLayoutView.jsx'

function AppShellInner() {
  const layout = useAppShellLayout()
  return <AppShellLayoutView layout={layout} />
}

export default function AppShell() {
  return (
    <SettingsModalProvider>
      <IntegrationsModalProvider>
        <AppShellInner />
      </IntegrationsModalProvider>
    </SettingsModalProvider>
  )
}
